import script from "./UserMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMenu.vue?vue&type=script&setup=true&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=2d11ce98&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d11ce98"]])

export default __exports__